import { render, staticRenderFns } from "./selection-row.vue?vue&type=template&id=63a7c46e"
import script from "./selection-row.vue?vue&type=script&lang=ts"
export * from "./selection-row.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports